module.exports = __webpack_public_path__ + "assets/img/29@3x.b137193b.png";